export const ROLE_PERMISSIONS = {
    CAN_VIEW_STANDARD_INGESTS: `can_view_standard_ingests`,
    CAN_CREATE_STANDARD_INGESTS: `can_create_standard_ingests`,
    CAN_EDIT_STANDARD_INGESTS: `can_edit_standard_ingests`,
    CAN_DELETE_STANDARD_INGESTS: `can_delete_standard_ingests`,
    FULL_ACCESS_TO_STREAMS: `full_access_to_streams`,
    FULL_ACCESS_TO_CAMPAIGNS: `full_access_to_campaigns`,
    CAN_VIEW_PRO_INGESTS: `can_view_pro_ingests`,
    CAN_VIEW_EGRESSES: `can_view_egresses`,
    CAN_DELETE_EGRESSES: `can_delete_egresses`,
    CAN_CREATE_EGRESSES: `can_create_egresses`,
    CAN_START_EGRESSES: `can_start_egresses`,
    CAN_STOP_EGRESSES: `can_stop_egresses`,
    CAN_EDIT_EGRESSES: `can_edit_egresses`,
    CAN_START_PRO_INGESTS: `can_start_pro_ingests`,
    CAN_STOP_PRO_INGESTS: `can_stop_pro_ingests`,
    CAN_CREATE_PRO_INGESTS: `can_create_pro_ingests`,
    CAN_EDIT_PRO_INGESTS: `can_edit_pro_ingests`,
    CAN_DELETE_PRO_INGESTS: `can_delete_pro_ingests`,
    CAN_START_LISTENERS: `can_start_listeners`,
    CAN_STOP_LISTENERS: `can_stop_listeners`,
    CAN_EDIT_LISTENERS: `can_edit_listeners`,
    CAN_DELETE_LISTENERS: `can_delete_listeners`,
    CAN_START_ON_DEMAND_STREAMS: `can_start_on_demand_streams`,
    CAN_STOP_ON_DEMAND_STREAMS: `can_stop_on_demand_streams`,
    CAN_ADD_NEW_CAMPAIGNS: `can_add_new_campaigns`,
    CAN_VIEW_CAMPAIGN_SETTINGS: `can_view_campaign_settings`,
    CAN_VIEW_STREAM_SETTINGS: `can_view_stream_settings`,
    CAN_VIEW_USAGE_DASHBOARD: `can_view_usage_dashboard`,
    CAN_SCHEDULE_STREAM: `can_schedule_stream`,
    CAN_ADD_NEW_USERS: `can_add_new_users`,
    CAN_EDIT_USERS: `can_edit_users`,
    CAN_DELETE_USERS: `can_delete_users`,
    CAN_ADD_SHARED_INTEGRATIONS: `can_add_shared_integrations`
};

const COMMON_ROLE_PERMISSIONS = [
    ROLE_PERMISSIONS.CAN_VIEW_STANDARD_INGESTS,
    ROLE_PERMISSIONS.CAN_CREATE_STANDARD_INGESTS,
    ROLE_PERMISSIONS.CAN_EDIT_STANDARD_INGESTS,
    ROLE_PERMISSIONS.CAN_DELETE_STANDARD_INGESTS
];

export const PERMISSIONS = {
    USER: [...COMMON_ROLE_PERMISSIONS],
    MANAGER: [
        ...COMMON_ROLE_PERMISSIONS,
        ROLE_PERMISSIONS.CAN_VIEW_EGRESSES,
        ROLE_PERMISSIONS.CAN_START_EGRESSES,
        ROLE_PERMISSIONS.CAN_STOP_EGRESSES,
        ROLE_PERMISSIONS.CAN_VIEW_PRO_INGESTS,
        ROLE_PERMISSIONS.CAN_START_PRO_INGESTS,
        ROLE_PERMISSIONS.CAN_STOP_PRO_INGESTS,
        ROLE_PERMISSIONS.CAN_EDIT_PRO_INGESTS,
        ROLE_PERMISSIONS.CAN_START_ON_DEMAND_STREAMS,
        ROLE_PERMISSIONS.CAN_STOP_ON_DEMAND_STREAMS,
        ROLE_PERMISSIONS.CAN_SCHEDULE_STREAM
    ],
    ADMIN: [
        ...COMMON_ROLE_PERMISSIONS,
        ROLE_PERMISSIONS.CAN_VIEW_EGRESSES,
        ROLE_PERMISSIONS.CAN_DELETE_EGRESSES,
        ROLE_PERMISSIONS.CAN_EDIT_EGRESSES,
        ROLE_PERMISSIONS.CAN_START_EGRESSES,
        ROLE_PERMISSIONS.CAN_STOP_EGRESSES,
        ROLE_PERMISSIONS.CAN_CREATE_EGRESSES,
        ROLE_PERMISSIONS.CAN_CREATE_STANDARD_INGESTS,
        ROLE_PERMISSIONS.CAN_EDIT_STANDARD_INGESTS,
        ROLE_PERMISSIONS.CAN_DELETE_STANDARD_INGESTS,
        ROLE_PERMISSIONS.FULL_ACCESS_TO_STREAMS,
        ROLE_PERMISSIONS.FULL_ACCESS_TO_CAMPAIGNS,
        ROLE_PERMISSIONS.CAN_VIEW_PRO_INGESTS,
        ROLE_PERMISSIONS.CAN_START_PRO_INGESTS,
        ROLE_PERMISSIONS.CAN_STOP_PRO_INGESTS,
        ROLE_PERMISSIONS.CAN_CREATE_PRO_INGESTS,
        ROLE_PERMISSIONS.CAN_EDIT_PRO_INGESTS,
        ROLE_PERMISSIONS.CAN_DELETE_PRO_INGESTS,
        ROLE_PERMISSIONS.CAN_START_ON_DEMAND_STREAMS,
        ROLE_PERMISSIONS.CAN_STOP_ON_DEMAND_STREAMS,
        ROLE_PERMISSIONS.CAN_ADD_NEW_CAMPAIGNS,
        ROLE_PERMISSIONS.CAN_VIEW_CAMPAIGN_SETTINGS,
        ROLE_PERMISSIONS.CAN_VIEW_STREAM_SETTINGS,
        ROLE_PERMISSIONS.CAN_VIEW_USAGE_DASHBOARD,
        ROLE_PERMISSIONS.CAN_SCHEDULE_STREAM,
        ROLE_PERMISSIONS.CAN_ADD_NEW_USERS,
        ROLE_PERMISSIONS.CAN_EDIT_USERS,
        ROLE_PERMISSIONS.CAN_DELETE_USERS,
        ROLE_PERMISSIONS.CAN_ADD_SHARED_INTEGRATIONS
    ]
};
